import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link, useParams } from "react-router-dom";
import ReactImageVideoLightbox from "react-image-video-lightbox";
import Modal from "react-modal";
import { useHistory } from "react-router";
import auth from "../../../helpers/auth";
import userProfile from "../../../assets/images/dummy-profile-pic.jpg";
import FormSpinner from "../../../components/Spinners/FormSpinner";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import { setProfileTabIndex, visitorProfileData } from "../modules/profile";
import constant from "../../../helpers/constant";
import { VisitorContact } from "../../contact/components/visitorContacts";
import { VisitorPost } from "../../Post/components/visitorPost";
import {
  acceptRejectRequestWithVisitorId,
  blockRequest,
  followUnfollowUser,
  sendConnectionRequest,
} from "../../NetworkConnection/modules/networkConnection";
import { unblockUserRequest } from "../../setting/module/UserSetting";
import ImporterModel from "../../../components/ConnectionModals/ImporterModal";
import { fetchDataConncetionSuggetion } from "../../B2B/modules/B2B";
import ConnectionModal from "../../../components/ConnectionModals/ConnectionModal";
import language from "../../../helpers/language";

import BlogView from "./BlogView";
import TripView from "./TripView";
import EventView from "./EventView";
import AwardView from "./AwardView";
//import SeeMore from '../../../components/SeeMore';
import ReactReadMoreReadLess from "react-read-more-read-less";
import ContentLoader from "react-content-loader";
import { blockUser, reportUser } from "../../home/modules/HomeModule";

export function VisitorProfileView(props) {
  const [blockPopup, setBlockPopup] = useState(false);
  const [isReportModal, setIsReportModal] = useState(false);
  const [isSubmitReport, setIsSubmitReport] = useState(false);
  const [reasonError, setReasonError] = useState(false);
  const [otherReason, setOtherReason] = useState("");
  const [allowOtherReason, setAllowOtherReason] = useState(false);
  const [otherReasonError, setOtherReasonError] = useState(false);
  const [addReason, setAddReason] = useState("");
  const [dotClick, setDotClick] = useState(false);
  const dispatch = useDispatch();
  const [lang] = useState(language.getLang());
  const params = useParams();
  const history = useHistory();
  const [connectedDropList, setConnectedDropList] = useState(false);
  const [contactInfo, setContactInfo] = useState(false);
  const [userType, setuserType] = useState();
  const [connectPopup, setConnectPopup] = useState(false);
  const [connectToImporter, setConnectToImporter] = useState(false);
  const [responseErrors, setResponseErrors] = useState("");
  const [connectText, setConnectText] = useState();
  const [connectLoader, setConnectLoader] = useState(false);
  const {
    visitorProfile: { data },
    profileData,
  } = useSelector((state) => state.memberProfileData);
  const { sendRequestSpinner } = useSelector(
    (state) => state.networkConnectionState
  );
  const [hide,setHide]=useState(true)
  const [featureProductViewModal, setFeatureProductViewModal] = useState(false);
  const [featureProductTitle, setFeatureProductTitle] = useState("");
  const [featureProductPhoto, setFeatureProductPhoto] = useState("");
  const [description, setDescription] = useState("");
  const [successMessages, setSuccessMessages] = useState({
    messages: "",
    type: 0,
  });
  const [featureProductUrl, setSeatureProductUrl] = useState("");
  const [userName, setUserName] = useState("");
  const [openConnectionModel, setOpenConnectionModel] = useState(false);
  const [isOpenImage, setIsOpenImage] = useState(false);
  const [userPhotosData, setUserPhotosData] = useState([]);
  const [imageIndex, setImageIndex] = useState(0);
  useEffect(async () => {
    const str = window.location.href;
    const getUrl = str.split("/");
    const bodyUrl = getUrl[getUrl.length - 1];
    document.body.classList.add(bodyUrl);
    document.body.classList.remove("addScroll");
    document.body.classList.remove("hidePageScroll");
    const userType = await auth.getUserType();
    await setuserType(JSON.parse(userType));
    await dispatch(setProfileTabIndex(0));
  }, []);

  useEffect(async () => {
    if (parseInt(params.id)) {
      await dispatch(visitorProfileData(parseInt(params.id)));
    }
  }, [parseInt(params.id)]);

  const sendRequest = async () => {
    const response = await dispatch(
      sendConnectionRequest({
        user_id: parseInt(params.id),
        reason_to_connect: connectText,
      })
    );
    if (response.success === 200) {
      await dispatch(
        fetchDataConncetionSuggetion({
          searchType: 2,
          roleId: data?.user_data?.role_id,
        })
      );
      await setConnectPopup(!connectPopup);
      await dispatch(visitorProfileData(parseInt(params.id)));
      setConnectText("");
    } else {
      setResponseErrors(response?.errors?.exception);
    }
    setTimeout(() => {
      setResponseErrors("");
    }, 3000);
  };

  const handleConnectToImporter = async () => {
    setConnectToImporter(!connectToImporter);
    setConnectLoader(true);
    // await dispatch(getConnectionProductType())
  };

  const handleMultiSelect = async (id, selectedList) => {
    const arr = [];
    (await selectedList) &&
      selectedList.map((item) => arr.push(item.user_field_option_id));
    await localStorage.setItem("productTypeArr", JSON.stringify(arr));
  };

  const followUnfollow = async () => {
    await setConnectLoader(true);
    const model = {
      follow_user_id: parseInt(params.id),
      follow_or_unfollow: data?.user_data?.follow_flag === 1 ? 0 : 1,
    };
    await dispatch(followUnfollowUser(model));
    await dispatch(visitorProfileData(parseInt(params.id)));
    await setConnectLoader(false);
  };

  const handleFeatureProduct = (id) => {
    data &&
      data.products.map((item) => {
        item.products
          .filter((item) => item.featured_listing_id == id)
          .map((item) => {
            setFeatureProductTitle(item.title);
            setDescription(item.description);
            setSeatureProductUrl(item.listing_url);
            setFeatureProductPhoto(
              `${item?.image?.base_url}${item?.image?.attachment_url}`
            );
            //console.log(data,"dfsdfsd");
          });
      });
  };

  const handleCancelReq = async () => {
    await setConnectedDropList(!connectedDropList);
    dispatch(
      acceptRejectRequestWithVisitorId({
        connection_id: parseInt(params.id),
        accept_or_reject: 3,
      })
    ).then(async (res) => {
      if (res.success === 200) {
        await dispatch(visitorProfileData(parseInt(params.id)));
        await dispatch(
          fetchDataConncetionSuggetion({
            searchType: 2,
            roleId: data?.user_data?.role_id,
          })
        );
        await setResponseErrors("");
      } else {
        setResponseErrors(res?.errors?.exception);
      }
    });
    setTimeout(() => {
      setResponseErrors("");
    }, 3000);
  };
  const declineRequest = async () => {
    await setUserName(
      data?.user_data?.restaurant_name ??
      data?.user_data?.company_name ??
      `${data?.user_data?.first_name} ${data?.user_data?.last_name}`
    );
    await setConnectedDropList(!connectedDropList);
    await setOpenConnectionModel(!openConnectionModel);
  };
  const handleBlockReq = async () => {
    setConnectedDropList(!connectedDropList);
    await dispatch(blockRequest({ block_user_id: parseInt(params.id) }));
    await dispatch(visitorProfileData(parseInt(params.id)));
  };

  const handleUnblockReq = async (isTrue) => {
    isTrue === undefined && setConnectedDropList(!connectedDropList);
    await dispatch(unblockUserRequest({ block_user_id: parseInt(params.id) }));
    await dispatch(visitorProfileData(parseInt(params.id)));
  };

  const handleAccept = async () => {
    setConnectedDropList(!connectedDropList);
    await dispatch(
      acceptRejectRequestWithVisitorId({
        connection_id: parseInt(params.id),
        accept_or_reject: 1,
      })
    );
    await dispatch(visitorProfileData(parseInt(params.id)));
  };

  const handleModal = async (newValue) => {
    await setConnectToImporter(newValue);
    await setOpenConnectionModel(newValue);
  };

  // photos gallery
  const handlePhotos = async (image) => {
    let userPhotos = [];
    await data?.posts?.data?.map((items) => {
      items?.attachments?.map((item) => {
        userPhotos.push({
          url: `${item?.attachment_link?.base_url}${item && item?.attachment_link?.attachment_url
            }`,
          type: "photo",
          altTag: "image",
        });
      });
    });
    userPhotos?.map((item, index) => {
      if (item?.url === image) {
        setImageIndex(index);
      }
    });

    await setUserPhotosData(userPhotos);
    await setIsOpenImage(true);
  };

  const rightSection = () => {
    return (
      <div className="tab-content-right-section">
        <Fragment>
          {/* ------------for--producer------------------------- */}

          {data?.hubConnectionRequest && <>
            {userType &&
              userType.role_id === constant.rolesId.producer &&
              data &&
              data.user_data &&
              data.user_data.role_id !== constant.rolesId.voyagers && (
                <div className="card card--block">
                  {/* Connect  */}
                  {data?.user_data?.available_to_connect === 1 &&
                    data &&
                    data.user_data.connection_flag === 0 && (
                      <div className="card-form">
                        <div className="view__hub__btn mt--0">
                          {profileData?.data?.user_data?.profile_percentage ===
                            100 ? (
                            <Link
                              to="#"
                              className="connect"
                              onClick={() => {
                                data.user_data.role_id ===
                                  constant.rolesId.importer ||
                                  (data &&
                                    data.user_data.role_id ===
                                    constant.rolesId.distributer) ||
                                  data.user_data.role_id ===
                                  constant.rolesId["importer&distributer"]
                                  ? handleConnectToImporter()
                                  : setConnectPopup(!connectPopup);
                              }}
                              style={
                                data?.user_data?.block_flag
                                  ? { pointerEvents: "none" }
                                  : null
                              }
                            >
                              {lang?.Connect}
                            </Link>
                          ) : (
                            <Link to="#" className="connect">
                              {lang?.Connect}
                            </Link>
                          )}
                        </div>
                      </div>
                    )}
                  {/* Connected */}
                  {data?.user_data?.connection_flag === 1 && (
                    <div className="card-form">
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Connected}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleCancelReq()}>
                                    {lang?.Remove} {lang?.Connections}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Pending */}
                  {data?.user_data?.connection_flag === 2 && (
                    <div className="card-form">
                      {" "}
                      <div className="view__hub__btn visitorProfile mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Pending}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleCancelReq()}>
                                    {lang?.Cancel_Request}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Respond */}
                  {data?.user_data?.connection_flag === 3 && (
                    <div className="card-form">
                      {" "}
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Respond}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>

                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleAccept()}>
                                    {lang?.Accept_Request}
                                  </Link>
                                </li>
                                <li>
                                  <Link to="#" onClick={() => declineRequest()}>
                                    {lang?.Delete_Request}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            {/* ------------for--importer------------------------- */}
            {(userType?.role_id === constant.rolesId.importer ||
              userType?.role_id === constant.rolesId.distributer ||
              userType?.role_id === constant.rolesId["importer&distributer"]) &&
              data?.user_data.role_id !== constant.rolesId.voyagers && (
                <div className="card card--block">
                  {/* Connect */}
                  {data?.user_data?.available_to_connect === 1 &&
                    data?.user_data?.connection_flag === 0 && (
                      <div className="card-form">
                        <div className="view__hub__btn mt--0">
                          {profileData?.data?.user_data?.profile_percentage ===
                            100 ? (
                            <Link
                              to="#"
                              className="connect"
                              onClick={() => {
                                data.user_data.role_id ===
                                  constant.rolesId["importer&distributer"]
                                  ? handleConnectToImporter()
                                  : setConnectPopup(!connectPopup);
                              }}
                              style={
                                data?.user_data?.block_flag
                                  ? { pointerEvents: "none" }
                                  : null
                              }
                            >
                              {lang?.Connect}{" "}
                            </Link>
                          ) : (
                            <Link to="#" className="connect">
                              {lang?.Connect}
                            </Link>
                          )}
                        </div>
                      </div>
                    )}
                  {/* Connected */}
                  {data?.user_data?.connection_flag === 1 && (
                    <div className="card-form">
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Connected}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleCancelReq()}>
                                    {lang?.only_Remove} {lang?.Connectionss}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Pending */}
                  {data?.user_data?.connection_flag === 2 && (
                    <div className="card-form">
                      {" "}
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Pending}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleCancelReq()}>
                                    {lang?.Cancel_Request}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>{" "}
                      </div>
                    </div>
                  )}
                  {/* Respond */}
                  {data?.user_data?.connection_flag === 3 && (
                    <div className="card-form">
                      {" "}
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Respond}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleAccept()}>
                                    {lang?.Accept_Request}
                                  </Link>
                                </li>
                                <li>
                                  <Link to="#" onClick={() => declineRequest()}>
                                    {lang?.Delete_Request}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

            {/* ------------for--restaurent------------------------- */}
            {userType &&
              userType.role_id === constant.rolesId.restaurant &&
              data?.user_data?.role_id !== constant.rolesId.voyagers && (
                <div className="card card--block">
                  {/* Connect */}
                  {data?.user_data?.available_to_connect === 1 &&
                    data &&
                    data.user_data.connection_flag === 0 && (
                      <div className="card-form">
                        <div className="view__hub__btn mt--0">
                          {profileData?.data?.user_data?.profile_percentage ===
                            100 ? (
                            <Link
                              to="#"
                              className="connect"
                              onClick={() => setConnectPopup(!connectPopup)}
                              style={
                                data?.user_data?.block_flag
                                  ? { pointerEvents: "none" }
                                  : null
                              }
                            >
                              {lang?.Connect}{" "}
                            </Link>
                          ) : (
                            <Link to="#" className="connect">
                              {lang?.Connect}{" "}
                            </Link>
                          )}
                        </div>
                      </div>
                    )}
                  {/* Connected */}
                  {data?.user_data?.connection_flag === 1 && (
                    <div className="card-form">
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Connected}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleCancelReq()}>
                                    {lang?.only_Remove} {lang?.Connections}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Pending */}
                  {data?.user_data?.connection_flag === 2 && (
                    <div className="card-form">
                      {" "}
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Pending}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleCancelReq()}>
                                    {lang?.Cancel_Request}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Respond */}
                  {data?.user_data?.connection_flag === 3 && (
                    <div className="card-form">
                      {" "}
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Respond}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleAccept()}>
                                    {lang?.Accept_Request}
                                  </Link>
                                </li>
                                <li>
                                  <Link to="#" onClick={() => declineRequest()}>
                                    {lang?.Delete_Request}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

            {/* ------------for--voice-of-expert------------------------- */}
            {userType &&
              userType.role_id === constant.rolesId.voiceOfExpert &&
              data &&
              data.user_data &&
              data.user_data.role_id !== constant.rolesId.voyagers && (
                <div className="card card--block">
                  {/* Connect */}
                  {data?.user_data?.available_to_connect === 1 &&
                    data &&
                    data.user_data.connection_flag === 0 && (
                      <div className="card-form">
                        <div className="view__hub__btn mt--0">
                          {profileData?.data?.user_data?.profile_percentage ===
                            100 ? (
                            <Link
                              to="#"
                              className="connect"
                              onClick={() => setConnectPopup(!connectPopup)}
                              style={
                                data?.user_data?.block_flag
                                  ? { pointerEvents: "none" }
                                  : null
                              }
                            >
                              {lang?.Connect}
                            </Link>
                          ) : (
                            <Link to="#" className="connect">
                              {lang?.Connect}
                            </Link>
                          )}
                        </div>
                      </div>
                    )}
                  {/* Connected */}
                  {data?.user_data?.connection_flag === 1 && (
                    <div className="card-form">
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Connected}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleCancelReq()}>
                                    {lang?.only_Remove} {lang?.Connections}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Pending */}
                  {data?.user_data?.connection_flag === 2 && (
                    <div className="card-form">
                      {" "}
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Pending}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleCancelReq()}>
                                    {lang?.Cancel_Request}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Respond */}
                  {data?.user_data?.connection_flag === 3 && (
                    <div className="card-form">
                      {" "}
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Respond}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleAccept()}>
                                    {lang?.Accept_Request}
                                  </Link>
                                </li>
                                <li>
                                  <Link to="#" onClick={() => declineRequest()}>
                                    {lang?.Delete_Request}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

            {/* ------------for--travel-agency------------------------- */}
            {userType &&
              userType.role_id === constant.rolesId.travelAgencies &&
              data?.user_data?.role_id !== constant.rolesId.voyagers && (
                <div className="card card--block">
                  {/* Connect */}
                  {data?.user_data?.available_to_connect === 1 &&
                    data &&
                    data.user_data.connection_flag === 0 && (
                      <div className="card-form">
                        <div className="view__hub__btn mt--0">
                          {profileData?.data?.user_data?.profile_percentage ===
                            100 ? (
                            <Link
                              to="#"
                              className="connect"
                              onClick={() => setConnectPopup(!connectPopup)}
                              style={
                                data?.user_data?.block_flag
                                  ? { pointerEvents: "none" }
                                  : null
                              }
                            >
                              {lang?.Connect}{" "}
                            </Link>
                          ) : (
                            <Link to="#" className="connect">
                              {lang?.Connect}{" "}
                            </Link>
                          )}
                        </div>
                      </div>
                    )}
                  {/* Connected */}
                  {data?.user_data?.connection_flag === 1 && (
                    <div className="card-form">
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Connected}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleCancelReq()}>
                                    {lang?.only_Remove} {lang?.Connections}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Pending */}
                  {data?.user_data?.connection_flag === 2 && (
                    <div className="card-form">
                      {" "}
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Pending}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleCancelReq()}>
                                    {lang?.Cancel_Request}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Respond */}
                  {data?.user_data?.connection_flag === 3 && (
                    <div className="card-form">
                      {" "}
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Respond}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleAccept()}>
                                    {lang?.Accept_Request}
                                  </Link>
                                </li>
                                <li>
                                  <Link to="#" onClick={() => declineRequest()}>
                                    {lang?.Delete_Request}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}

            {/* ------------for--voyegers------------------------- */}
            {userType &&
              userType.role_id === constant.rolesId.voyagers &&
              data?.user_data?.role_id === constant.rolesId.voyagers && (
                <div className="card card--block">
                  {/* Connect */}
                  {data?.user_data?.available_to_connect === 1 &&
                    data &&
                    data.user_data.connection_flag === 0 && (
                      <div className="card-form">
                        <div className="view__hub__btn mt--0">
                          {profileData?.data?.user_data?.profile_percentage ===
                            100 ? (
                            <Link
                              style={
                                data?.user_data?.block_flag
                                  ? { pointerEvents: "none" }
                                  : null
                              }
                              to="#"
                              className="connect"
                              onClick={() => setConnectPopup(!connectPopup)}
                            >
                              {lang?.Connect}
                            </Link>
                          ) : (
                            <Link to="#" className="connect">
                              {lang?.Connect}
                            </Link>
                          )}
                        </div>
                      </div>
                    )}
                  {/* Connected */}
                  {data?.user_data?.connection_flag === 1 && (
                    <div className="card-form">
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Connected}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleCancelReq()}>
                                    {lang?.only_Remove} {lang?.Connectionss}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Pending */}
                  {data?.user_data?.connection_flag === 2 && (
                    <div className="card-form">
                      {" "}
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Pending}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleCancelReq()}>
                                    {lang?.Cancel_Request}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  {/* Respond */}
                  {data?.user_data?.connection_flag === 3 && (
                    <div className="card-form">
                      {" "}
                      <div className="view__hub__btn mt--0">
                        <div className="editProfileBtn connect">
                          <div className="edit__profile editBtn">
                            <span className="edit__profile-btn">
                              {lang?.Respond}
                            </span>
                            <span
                              className="edit__pics"
                              onClick={() =>
                                setConnectedDropList(!connectedDropList)
                              }
                            >
                              {" "}
                              <i className="fas fa-caret-down" />
                            </span>
                          </div>
                          {connectedDropList && (
                            <div className="postView">
                              <ul>
                                <li>
                                  <Link to="#" onClick={() => handleAccept()}>
                                    {lang?.Accept_Request}
                                  </Link>
                                </li>
                                <li>
                                  <Link to="#" onClick={() => declineRequest()}>
                                    {lang?.Delete_Request}
                                  </Link>
                                </li>
                                {data?.user_data?.block_flag === 0 && (
                                  <li>
                                    <Link to="#" onClick={() => handleBlockReq()}>
                                      {lang?.Block}
                                    </Link>
                                  </li>
                                )}
                                {data?.user_data?.block_flag === 1 && (
                                  <li>
                                    <Link
                                      to="#"
                                      onClick={() => handleUnblockReq()}
                                    >
                                      {lang?.UnBlock}
                                    </Link>
                                  </li>
                                )}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              )}
            {userType &&
              userType.role_id === constant.rolesId.voyagers &&
              data?.user_data?.role_id !== constant.rolesId.voyagers && (
                <div className="card card--block">
                  {/* follow */}
                  {data?.user_data?.available_to_follow === 1 &&
                    data?.user_data?.follow_flag === 1 && (
                      <div className="card-form">
                        <div className="view__hub__btn mt--0 followLoader">
                          {" "}
                          <Link
                            to="#"
                            className="connect"
                            onClick={() => followUnfollow()}
                          >
                            {" "}
                            {connectLoader ? <FormSpinner /> : lang?.Unfollow}
                          </Link>
                        </div>{" "}
                      </div>
                    )}
                  {/* Unfollow */}
                  {data?.user_data?.available_to_follow === 1 &&
                    data?.user_data?.follow_flag === 0 && (
                      <div className="card-form">
                        <div className="view__hub__btn mt--0 followLoader">
                          {" "}
                          <Link
                            to="#"
                            className="connect"
                            onClick={() => followUnfollow()}
                          >
                            {connectLoader ? <FormSpinner /> : lang?.Follow}
                          </Link>
                        </div>
                      </div>
                    )}
                </div>
              )}
          </>}
          {/* Fearture Products */}
          {data &&
            data.products?.length > 0 &&
            data.products[0].products?.length > 0 && (
              <div className="card card--block">
                <div className="featured__products">
                  <div className="block__title flex justify-between">
                    {" "}
                    <p>{data.products[0].title}</p>{" "}
                  </div>
                  <div className="featureWrapper pt-4">
                    {data ? (
                      data.products.map((item) => {
                        return (
                          <Fragment>
                            {item.products.map((res) => {
                              return (
                                <div className="featured__products">
                                  <div className="">
                                    <div className="w-1/2 mb-2">
                                      <div
                                        className="img_container"
                                        onClick={() => {
                                          handleFeatureProduct(
                                            res.featured_listing_id
                                          );
                                          setFeatureProductViewModal(true);
                                          setHide(true)
                                        }}
                                      >
                                        <img
                                          src={
                                            res &&
                                            res.image !== null &&
                                            res &&
                                            res.image &&
                                            `${res?.image?.base_url}${res?.image?.attachment_url}`
                                          }
                                        />
                                      </div>
                                      <div style={{ textAlign: "center" }}>
                                        {" "}
                                        <a
                                          // href={res.listing_url}
                                          // target="_blank"
                                          onClick={() => {
                                            handleFeatureProduct(
                                              res.featured_listing_id
                                            );
                                            setFeatureProductViewModal(true);
                                            setHide(false)
                                          }}
                                        >
                                          {" "}
                                          <p>{res.title}</p>
                                        </a>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              );
                            })}
                          </Fragment>
                        );
                      })
                    ) : (
                      <div className="featured__products">
                        <div className="img_container">
                          <span className="featured-product-delete">
                            <i className="far fa-trash-alt" />
                          </span>
                          <p>{lang?.Nothing_added_yet}</p>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          {/* Fearture Products */}
        </Fragment>
      </div>
    );
  };

  const addPostReason = (reason) => {
    setAddReason(reason);
    setReasonError(false);
    if (reason === "Other") {
      setAllowOtherReason(true);
    } else {
      setAllowOtherReason(false);
      setOtherReason("");
    }
  };

  // Submit Report user
  const reportUsers = async (event) => {
    event.preventDefault();
    if (addReason != "") {
      let excute = true;
      let reason = addReason;
      if (addReason === "Other") {
        if (otherReason === "") {
          setOtherReasonError(true);
          excute = false;
        }
      } else {
        setOtherReasonError(false);
      }
      if (excute) {
        const postData = {
          user_id: params.id,
          report_as: reason,
          message: otherReason,
        };
        await setIsSubmitReport(true);
        await dispatch(reportUser(postData))
          .then(async (res) => {
            if (res && res.success === 200) {
              setSuccessMessages({
                messages: "Your report has been successfully sumbited.",
                type: 1,
              });
              await setAddReason("");
              await setIsReportModal(false);
              await setIsSubmitReport(false);
              await setReasonError(false);
              await setAllowOtherReason(false);
              await setOtherReason("");
              await setOtherReasonError(false);
              setTimeout(() => {
                setSuccessMessages({ messages: "", type: 0 });
                history.push("/home");
              }, 3000);
            } else {
              setSuccessMessages({ messages: "", type: 2 });
              await setIsSubmitReport(false);
            }
          })
          .catch((error) => { });
      }
    } else {
      setReasonError(true);
    }
  };

  // block user
  const blockUsers = async () => {
    await dispatch(blockUser(params.id))
      .then(async (res) => {
        if (res?.success === 200) {
          setBlockPopup(false);
          setSuccessMessages({ messages: "user block successfully.", type: 1 });
          setTimeout(() => {
            setSuccessMessages({ messages: "", type: 0 });
            history.push("/home");
          }, 3000);
        } else {
          setSuccessMessages({ messages: lang?.SomeThingsWrong, type: 2 });
        }
      })
      .catch((error) => console.log(error));
  };


  return (
    <Fragment>
      {openConnectionModel && (
        <ConnectionModal
          openModelData={{
            openModel: openConnectionModel,
            user_id: parseInt(params.id),
            visitor_id: parseInt(params.id),
            name: userName,
            network: true,
            handleOpenModel: handleModal,
            from: `${lang?.Decline}`,
            visitor: true,
            view: false,
          }}
        />
      )}
      <div className="home__page profile__page">
        {/* Layout Content */}
        {/* Profile Cover pic as Banner */}
        <div className="profile__cover ">
          <Fragment>
            <div className="cover__pic withOverLay">
              {data?.user_data?.cover_id ? (
                <img
                  src={`${data?.user_data?.cover_id?.base_url}${data?.user_data?.cover_id?.attachment_url}`}
                />
              ) : (
                <ContentLoader
                  viewBox="0 0 24 8"
                  speed={2}
                  width={"100%"}
                  height={"100%"}
                  backgroundColor="#bababa"
                  foregroundColor="#a29a9a"
                >
                  <rect x="0" y="0" rx="0" ry="0" width="100%" height="100%" />
                </ContentLoader>
              )}
              <div
                className="about_profile rightSide"
                onClick={() => {
                  setDotClick(!dotClick);
                }}
              >
                <i className="fa fa-ellipsis-v" aria-hidden="true"></i>
              </div>


              {dotClick && (
                <div className="postView profileOption">
                  <ul>
                    <li
                      onClick={() => {
                        setIsReportModal(!isReportModal);
                      }}
                    >
                      <Link>
                        <span>
                          <i className="fa fa-pencil" aria-hidden="true"></i>
                        </span>
                        Report User
                      </Link>
                    </li>
                    <li onClick={() => setBlockPopup(!blockPopup)}>
                      <Link>
                        <span>
                          <i className="fa fa-ban" aria-hidden="true"></i>
                        </span>
                        {!data?.user_data?.block_flag
                          ? lang?.Block
                          : lang?.UnBlock}
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </div>
            {successMessages?.messages !== "" && (
              <div className="successMsg profile">
                <div className="" style={{ color: successMessages?.type === 1 ? "red" : "green", }}>
                  {successMessages?.messages}
                </div>
              </div>
            )}
          </Fragment>
        </div>


        <div className="site-align top-align">
          {/* Left Block */}
          <div className="left__section-block profile__left-section md:mb-1 sm:mb-2">
            <div className="card card--block">
              <div className="user_profile-detail p--6">
                <div
                  className="user__pic"
                  style={{
                    border: `${"0.313rem solid"}#${data?.user_data
                      ? data?.user_data?.profile_color
                      : "rgb(171, 99, 147)"
                      }`,
                  }}
                >
                  {data?.user_data?.avatar_id ? (
                    <img
                      src={
                        data?.user_data?.avatar_id !== null
                          ? `${data?.user_data?.avatar_id.base_url}${data?.user_data?.avatar_id.attachment_large_url}`
                          : userProfile
                      }
                      alt="Profile Image"
                    />
                  ) : (
                    <FormSpinner />
                  )}
                </div>
                <div className="user__name text-center mt-3 mb-3">
                  <span className="user_cate">
                    {data?.user_data
                      ? data?.user_data?.company_name ??
                      data?.user_data?.restaurant_name ??
                      `${data?.user_data?.first_name} ${data?.user_data?.last_name}`
                      : ""}
                  </span>
                </div>
                <div className="profile__bg__white left-block text-center">
                  <div className="flex mt-3 mb-3 profile__Post">
                    <div className="w-1/3">
                      <div className="outer__div">
                        <h6>
                          {lang?.Posts}{" "}
                          <span className="flex">{data?.post_count}</span>
                        </h6>
                      </div>
                    </div>
                    <div className="w-1/3">
                      <div className="outer__div">
                        <h6>
                          {lang?.Connections}{" "}
                          <span className="flex">{data?.connection_count}</span>
                        </h6>
                      </div>
                    </div>
                    <div className="w-1/3">
                      <div className="outer__div">
                        <h6>
                          {lang?.Followers}{" "}
                          <span className="flex">{data?.follower_count}</span>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="right-block-mobile">
              <div className="card card--block">{rightSection()}</div>
            </div>
            <div className="card card--block mt-2">
              <div className="user_all_detail p-4">
                {data?.about_tab.map((item, index) => {
                  if (item.type === "checkbox") {
                    const val = item?.value.split(",");
                    return (
                      <Fragment key={index}>
                        <div className="blockRow">
                          <h4 className="font-size-18 pb-2">{item.title}</h4>
                          <div className="selectedProduct">
                            <ul>
                              {val &&
                                val.map((v, i) => (
                                  <li>
                                    <Link to="#" key={i}>
                                      {v}
                                    </Link>
                                  </li>
                                ))}
                            </ul>
                          </div>
                        </div>
                      </Fragment>
                    );
                  }
                  if (item.type === "multiselect") {
                    return (
                      <Fragment key={index}>
                        <div className="blockRow">
                          <h4 className="font-size-18 pb-2">{item.title}</h4>
                          <p className="">{item.value}</p>
                        </div>
                      </Fragment>
                    );
                  } else {
                    if (item.value != "0%") {
                      return (
                        <Fragment key={index}>
                          <div className="blockRow">
                            <h4 className="font-size-18 pb-2">{item.title}</h4>
                            {item.type === "text" ? (
                              <Fragment>
                                <ReactReadMoreReadLess
                                  charLimit={150}
                                  readMoreText={"See more"}
                                  readLessText={"See less"}
                                  readMoreClassName="read-more-less--more"
                                  readLessClassName="read-more-less--less"
                                >
                                  {item?.value}
                                </ReactReadMoreReadLess>
                                {/* <SeeMore item={item} /> */}
                              </Fragment>
                            ) : (
                              <p className="">{item.value}</p>
                            )}
                          </div>
                        </Fragment>
                      );
                    }
                  }
                })}
              </div>
            </div>
          </div>

          {/*  Center Section */}
          <div className="tabs middle__section-block">
            <div className="tab__list">
              <Tabs>
                <TabList className="TabUpperList">
                  <Tab
                    className="TabInnerList"
                    onClick={() => setContactInfo(false)}
                  >
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M8.72727 9.81818H7.27273C6.67018 9.81818 6.18182 9.32982 6.18182 8.72727V7.27273C6.18182 6.67018 6.67018 6.18182 7.27273 6.18182H8.72727C9.32982 6.18182 9.81818 6.67018 9.81818 7.27273V8.72727C9.81818 9.32982 9.32982 9.81818 8.72727 9.81818ZM3.63636 8.72727V7.27273C3.63636 6.67018 3.148 6.18182 2.54545 6.18182H1.09091C0.488364 6.18182 0 6.67018 0 7.27273V8.72727C0 9.32982 0.488364 9.81818 1.09091 9.81818H2.54545C3.148 9.81818 3.63636 9.32982 3.63636 8.72727ZM16 8.72727V7.27273C16 6.67018 15.5116 6.18182 14.9091 6.18182H13.4545C12.852 6.18182 12.3636 6.67018 12.3636 7.27273V8.72727C12.3636 9.32982 12.852 9.81818 13.4545 9.81818H14.9091C15.5116 9.81818 16 9.32982 16 8.72727ZM9.81818 14.9091V13.4545C9.81818 12.852 9.32982 12.3636 8.72727 12.3636H7.27273C6.67018 12.3636 6.18182 12.852 6.18182 13.4545V14.9091C6.18182 15.5116 6.67018 16 7.27273 16H8.72727C9.32982 16 9.81818 15.5116 9.81818 14.9091ZM3.63636 14.9091V13.4545C3.63636 12.852 3.148 12.3636 2.54545 12.3636H1.09091C0.488364 12.3636 0 12.852 0 13.4545V14.9091C0 15.5116 0.488364 16 1.09091 16H2.54545C3.148 16 3.63636 15.5116 3.63636 14.9091ZM16 14.9091V13.4545C16 12.852 15.5116 12.3636 14.9091 12.3636H13.4545C12.852 12.3636 12.3636 12.852 12.3636 13.4545V14.9091C12.3636 15.5116 12.852 16 13.4545 16H14.9091C15.5116 16 16 15.5116 16 14.9091ZM9.81818 2.54545V1.09091C9.81818 0.488364 9.32982 0 8.72727 0H7.27273C6.67018 0 6.18182 0.488364 6.18182 1.09091V2.54545C6.18182 3.148 6.67018 3.63636 7.27273 3.63636H8.72727C9.32982 3.63636 9.81818 3.148 9.81818 2.54545ZM3.63636 2.54545V1.09091C3.63636 0.488364 3.148 0 2.54545 0H1.09091C0.488364 0 0 0.488364 0 1.09091V2.54545C0 3.148 0.488364 3.63636 1.09091 3.63636H2.54545C3.148 3.63636 3.63636 3.148 3.63636 2.54545ZM16 2.54545V1.09091C16 0.488364 15.5116 0 14.9091 0H13.4545C12.852 0 12.3636 0.488364 12.3636 1.09091V2.54545C12.3636 3.148 12.852 3.63636 13.4545 3.63636H14.9091C15.5116 3.63636 16 3.148 16 2.54545Z"
                        fill="url(#paint0_linear_563_7873)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_563_7873"
                          x1="8"
                          y1="21.9618"
                          x2="8"
                          y2="-7.75891"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#15AEDE" />
                          <stop offset="0.158" stopColor="#195DE1" />
                          <stop offset="0.724" stopColor="#28A1EC" />
                          <stop offset="1" stopColor="#2EB5F0" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>{lang?.only_Post}</span>
                  </Tab>
                  <Tab
                    className="TabInnerList"
                    onClick={() => setContactInfo(false)}
                  >
                    <svg
                      width="21"
                      height="18"
                      viewBox="0 0 21 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M18.117 0H2.013C0.90585 0 0 0.947294 0 2.1051V15.7882C0 16.946 0.90585 17.8933 2.013 17.8933H18.117C19.2241 17.8933 20.13 16.946 20.13 15.7882V2.1051C20.13 0.947294 19.2241 0 18.117 0Z"
                        fill="#8CC5C2"
                      />
                      <path
                        d="M18.8716 1.91699H1.25781V15.976H18.8716V1.91699Z"
                        fill="url(#paint0_linear_563_7880)"
                      />
                      <path
                        d="M18.8727 15.9764H12.582L16.2872 10.5956C16.6269 10.1035 17.344 10.1035 17.6837 10.5956L18.8727 12.321V15.9764Z"
                        fill="url(#paint1_linear_563_7880)"
                      />
                      <path
                        d="M16.6073 15.9762H6.03906L10.6249 9.31729C10.9646 8.82523 11.6818 8.82523 12.0214 9.31729L16.6073 15.9762Z"
                        fill="url(#paint2_linear_563_7880)"
                      />
                      <path
                        d="M11.4486 15.9762H1.25781V10.3142L3.70487 6.76114C4.04456 6.26907 4.76169 6.26907 5.10138 6.76114L11.4486 15.9762Z"
                        fill="url(#paint3_linear_563_7880)"
                      />
                      <path
                        d="M15.7269 3.83447C15.3932 3.83447 15.0732 3.96913 14.8372 4.20882C14.6013 4.44851 14.4688 4.7736 14.4688 5.11257C14.4688 5.45154 14.6013 5.77663 14.8372 6.01632C15.0732 6.25601 15.3932 6.39066 15.7269 6.39066C16.0605 6.39066 16.3806 6.25601 16.6165 6.01632C16.8524 5.77663 16.985 5.45154 16.985 5.11257C16.985 4.7736 16.8524 4.44851 16.6165 4.20882C16.3806 3.96913 16.0605 3.83447 15.7269 3.83447Z"
                        fill="url(#paint4_linear_563_7880)"
                      />
                      <defs>
                        <linearGradient
                          id="paint0_linear_563_7880"
                          x1="10.0647"
                          y1="2.23651"
                          x2="10.0647"
                          y2="14.5382"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#CBFFFC" />
                          <stop offset="1" stopColor="#5BEFE8" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_563_7880"
                          x1="12.582"
                          y1="13.1015"
                          x2="18.8727"
                          y2="13.1015"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#16A085" />
                          <stop offset="1" stopColor="#F4D03F" />
                        </linearGradient>
                        <linearGradient
                          id="paint2_linear_563_7880"
                          x1="6.03906"
                          y1="12.4622"
                          x2="16.6073"
                          y2="12.4622"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#16A085" />
                          <stop offset="1" stopColor="#F4D03F" />
                        </linearGradient>
                        <linearGradient
                          id="paint3_linear_563_7880"
                          x1="1.25781"
                          y1="11.1841"
                          x2="11.4486"
                          y2="11.1841"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#16A085" />
                          <stop offset="1" stopColor="#F4D03F" />
                        </linearGradient>
                        <linearGradient
                          id="paint4_linear_563_7880"
                          x1="14.4
                          {console.log(item, 'id')}688"
                          y1="5.11257"
                          x2="16.985"
                          y2="5.11257"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#FFD25F" />
                          <stop offset="1" stopColor="#FFB448" />
                        </linearGradient>
                      </defs>
                    </svg>
                    <span>{lang?.Photos}</span>
                  </Tab>
                  <Tab
                    className="TabInnerList"
                    onClick={() => setContactInfo(false)}
                  >
                    <svg
                      width="21"
                      height="21"
                      viewBox="0 0 21 21"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <g clipPath="url(#clip0_544_8177)">
                        <path
                          d="M15.0997 5.63679C15.0997 8.3164 12.9561 10.4601 10.2764 10.4601C7.59682 10.4601 5.45312 8.3164 5.45312 5.63679C5.45312 2.95717 7.59682 0.813477 10.2764 0.813477C12.9561 0.813477 15.0997 2.95717 15.0997 5.63679Z"
                          fill="url(#paint0_linear_544_8177)"
                        />
                        <path
                          d="M20.1326 17.6976C20.1326 17.6976 17.3947 12.1377 10.2763 12.1377C3.15779 12.1377 0.419922 17.6976 0.419922 17.6976V20.9455H20.1326V17.6976Z"
                          fill="url(#paint1_linear_544_8177)"
                        />
                      </g>
                      <defs>
                        <linearGradient
                          id="paint0_linear_544_8177"
                          x1="5.45312"
                          y1="0.813477"
                          x2="15.0997"
                          y2="10.4601"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#FEC163" />
                          <stop offset="1" stopColor="#DE4313" />
                        </linearGradient>
                        <linearGradient
                          id="paint1_linear_544_8177"
                          x1="0.419922"
                          y1="12.1377"
                          x2="6.98089"
                          y2="26.8218"
                          gradientUnits="userSpaceOnUse"
                        >
                          <stop stopColor="#6B73FF" />
                          <stop offset="1" stopColor="#000DFF" />
                        </linearGradient>
                        <clipPath id="clip0_544_8177">
                          <rect
                            width="20.1321"
                            height="20.1321"
                            fill="white"
                            transform="translate(0 0.8125)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                    <span>
                      {" "}
                      {data?.user_data?.role_id == constant.rolesId.voyagers ||
                        data?.user_data?.role_id == constant.rolesId.voiceOfExpert
                        ? lang?.only_about
                        : lang?.About_us}
                    </span>
                  </Tab>
                  {data?.contact_tab?.enableTab && (
                    <Tab className="TabInnerList">
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clipPath="url(#clip0_544_8192)">
                          <path
                            d="M16.8204 20.9456H4.02539V0.813477H16.8204C17.9031 0.813477 18.7889 1.71942 18.7889 2.82668V18.9323C18.7889 20.0396 17.9031 20.9456 16.8204 20.9456Z"
                            fill="url(#paint0_linear_544_8192)"
                          />
                          <path
                            d="M3.13131 0.813477H4.02607V20.9456H3.13131C2.14708 20.9456 1.3418 20.0396 1.3418 18.9323V2.82668C1.3418 1.71942 2.14708 0.813477 3.13131 0.813477Z"
                            fill="url(#paint1_linear_544_8192)"
                          />
                          <path
                            d="M11.0717 6.85254C10.5124 6.85254 9.97593 7.06464 9.5804 7.44219C9.18487 7.81974 8.96267 8.33181 8.96267 8.86575C8.96267 9.39968 9.18487 9.91175 9.5804 10.2893C9.97593 10.6668 10.5124 10.879 11.0717 10.879C11.6311 10.879 12.1676 10.6668 12.5631 10.2893C12.9586 9.91175 13.1808 9.39968 13.1808 8.86575C13.1808 8.33181 12.9586 7.81974 12.5631 7.44219C12.1676 7.06464 11.6311 6.85254 11.0717 6.85254ZM14.7626 13.8988C14.7626 13.8988 13.7608 11.8856 11.0717 11.8856C8.38267 11.8856 7.38086 13.8988 7.38086 13.8988V14.9054H14.7626V13.8988Z"
                            fill="url(#paint2_linear_544_8192)"
                          />
                        </g>
                        <defs>
                          <linearGradient
                            id="paint0_linear_544_8192"
                            x1="4.02539"
                            y1="10.8795"
                            x2="18.7889"
                            y2="10.8795"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#F77062" />
                            <stop offset="1" stopColor="#FE5196" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_544_8192"
                            x1="4.02607"
                            y1="10.8795"
                            x2="1.3418"
                            y2="10.8795"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#D64638" />
                            <stop offset="1" stopColor="#E03177" />
                          </linearGradient>
                          <linearGradient
                            id="paint2_linear_544_8192"
                            x1="7.38086"
                            y1="10.879"
                            x2="14.7626"
                            y2="10.879"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="white" />
                          </linearGradient>
                          <clipPath id="clip0_544_8192">
                            <rect
                              width="20.1321"
                              height="20.1321"
                              fill="white"
                              transform="translate(0 0.8125)"
                            />
                          </clipPath>
                        </defs>
                      </svg>
                      <span>{lang?.Contact}</span>
                    </Tab>
                  )}

                  {data?.user_data?.role_id !== constant.rolesId.voyagers && (
                    <Tab
                      className="TabInnerList"
                      onClick={() => setContactInfo(false)}
                    >
                      <svg
                        width="21"
                        height="21"
                        viewBox="0 0 21 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.66666 7.14218L11.9048 11.285L16.3333 11.9041L13.1428 15.0946L13.9524 19.9993L9.66666 17.6184L5.38095 19.9993L6.19047 15.0946L3 11.9041L7.42857 11.285L9.66666 7.14218ZM10.619 7.14218H8.71428C8.19047 7.14218 7.7619 6.71361 7.7619 6.1898V5.71361C7.7619 5.1898 8.19047 4.76123 8.71428 4.76123H10.619C11.1428 4.76123 11.5714 5.1898 11.5714 5.71361V6.1898C11.5714 6.71361 11.1428 7.14218 10.619 7.14218ZM8.71428 5.71361V6.1898H10.619V5.71361H8.71428Z"
                          fill="url(#paint0_linear_544_8183)"
                        />
                        <path
                          d="M9.66666 11.4283C10.2857 11.4283 10.8571 11.6188 11.2857 11.9521L11.8571 11.2854L9.66666 7.14258V11.4283ZM13.1428 15.095L16.3333 11.9045L12.2381 13.095C12.4286 13.4759 12.5238 13.8569 12.5238 14.2854C12.5238 14.4759 12.5238 14.6664 12.4762 14.8092L13.1428 15.095ZM9.66666 17.1426V17.6188L13.9524 19.9997L11.5238 16.4759C11 16.9045 10.3809 17.1426 9.66666 17.1426ZM6.85714 14.8092L6.19047 15.0473L5.38095 19.9997L7.80952 16.4759C7.33333 16.0473 7 15.4759 6.85714 14.8092ZM8.04761 11.9521L7.47619 11.2854L3 11.9045L7.09523 13.095C7.28571 12.6188 7.61904 12.2378 8.04761 11.9521ZM11.5714 14.2854C11.5714 15.333 10.7143 16.1902 9.66666 16.1902C8.61904 16.1902 7.7619 15.333 7.7619 14.2854C7.7619 13.2378 8.61904 12.3807 9.66666 12.3807C10.7143 12.3807 11.5714 13.2378 11.5714 14.2854Z"
                          fill="url(#paint1_linear_544_8183)"
                        />
                        <path
                          d="M4.42773 0H14.9039V2.38095L10.6182 6.19047H8.71344L4.42773 2.38095V0Z"
                          fill="#004577"
                        />
                        <path
                          d="M13.0006 0H6.33398V4.09523L8.71493 6.19047H10.6197L13.0006 4.09523V0Z"
                          fill="#00EAFF"
                        />
                        <path
                          d="M8.71484 0H10.6196V6.19047H8.71484V0Z"
                          fill="#004577"
                        />
                        <defs>
                          <linearGradient
                            id="paint0_linear_544_8183"
                            x1="3"
                            y1="4.76123"
                            x2="18.1032"
                            y2="17.9766"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FDEB71" />
                            <stop offset="1" stopColor="#F8D800" />
                          </linearGradient>
                          <linearGradient
                            id="paint1_linear_544_8183"
                            x1="3"
                            y1="7.14258"
                            x2="15.8486"
                            y2="20.4671"
                            gradientUnits="userSpaceOnUse"
                          >
                            <stop stopColor="#FD6E6A" />
                            <stop offset="1" stopColor="#FFC600" />
                          </linearGradient>
                        </defs>
                      </svg>
                      <span>{lang?.Awards}</span>
                    </Tab>
                  )}
                  {data?.user_data?.role_id ===
                    constant.rolesId.voiceOfExpert && (
                      <Tab
                        className="TabInnerList"
                        onClick={() => setContactInfo(false)}
                      >
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M17.875 3.6665H4.125C3.36554 3.6665 2.75 4.28205 2.75 5.0415V15.5832C2.75 16.3422 3.36554 16.9582 4.125 16.9582H5.5V20.1665L9.4215 16.9582H17.875C18.634 16.9582 19.25 16.3422 19.25 15.5832V5.0415C19.25 4.28205 18.634 3.6665 17.875 3.6665Z"
                            fill="url(#paint0_linear_657_18)"
                          />
                          <path
                            d="M7.33333 13.2918L5.5 10.0835V8.7085H9.16667V10.0835L7.33333 13.2918Z"
                            fill="white"
                          />
                          <path
                            d="M9.16663 10.0832L7.3333 9.62484L5.50134 10.0832V2.2915H9.16663V10.0832Z"
                            fill="#004577"
                          />
                          <path
                            d="M6.54773 11.9165L7.33331 13.2915L8.1189 11.9165H6.54773Z"
                            fill="#004577"
                          />
                          <path
                            d="M7.33337 2.2915V9.62484L9.16671 10.0832V2.2915H7.33337Z"
                            fill="#46A7ED"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_657_18"
                              x1="2.75"
                              y1="3.6665"
                              x2="19.25"
                              y2="20.1665"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#FFE985" />
                              <stop offset="1" stopColor="#FA742B" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <span>{lang?.Blogs}</span>
                      </Tab>
                    )}
                  {data?.user_data?.role_id ===
                    constant.rolesId.travelAgencies && (
                      <Tab
                        className="TabInnerList"
                        onClick={() => setContactInfo(false)}
                      >
                        <svg
                          width="22"
                          height="22"
                          viewBox="0 0 22 22"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M16.5001 5.95842C17.5107 5.95842 18.3334 5.13571 18.3334 4.12508C18.3334 3.11446 17.5107 2.29175 16.5001 2.29175C15.4895 2.29175 14.6667 3.11446 14.6667 4.12508C14.6667 5.13571 15.4895 5.95842 16.5001 5.95842Z"
                            fill="url(#paint0_linear_675_361)"
                          />
                          <path
                            d="M3.24243 18.3816L10.1172 11.5065L10.7654 12.1547L3.89062 19.0298L3.24243 18.3816Z"
                            fill="url(#paint1_linear_675_361)"
                          />
                          <path
                            d="M10.0833 12.8333C9.85049 12.8333 9.61811 12.7457 9.43982 12.5693C9.07911 12.2136 9.07545 11.6333 9.43066 11.2731L13.6702 6.97622C14.0259 6.6146 14.6062 6.61139 14.9664 6.96706C15.3271 7.32272 15.3308 7.90297 14.9756 8.26322L10.736 12.5601C10.5563 12.7425 10.3203 12.8333 10.0833 12.8333Z"
                            fill="url(#paint2_linear_675_361)"
                          />
                          <path
                            d="M6.86346 13.303C6.54996 12.99 6.13975 12.8333 5.72909 12.8333C5.31842 12.8333 4.90821 12.99 4.59471 13.303C4.24454 13.6532 2.65504 15.2427 2.30304 15.5947C1.99046 15.9073 1.83371 16.3166 1.83325 16.7263C1.83279 17.1379 1.98909 17.5495 2.30304 17.8635C2.92959 18.49 3.66659 19.2499 3.66659 19.2499L8.24992 14.6666C8.24992 14.6666 7.05871 13.4983 6.86346 13.303Z"
                            fill="url(#paint3_linear_675_361)"
                          />
                          <path
                            d="M4.12492 17.875C3.8818 17.875 3.64865 17.9716 3.47674 18.1435C3.30483 18.3154 3.20825 18.5486 3.20825 18.7917C3.20825 19.0348 3.30483 19.2679 3.47674 19.4398C3.64865 19.6118 3.8818 19.7083 4.12492 19.7083C4.36803 19.7083 4.60119 19.6118 4.7731 19.4398C4.94501 19.2679 5.04159 19.0348 5.04159 18.7917C5.04159 18.5486 4.94501 18.3154 4.7731 18.1435C4.60119 17.9716 4.36803 17.875 4.12492 17.875Z"
                            fill="url(#paint4_linear_675_361)"
                          />
                          <path
                            d="M15.9774 10.0283L15.0836 12.98L14.387 12.1321L15.322 9.03833L15.9774 10.0283Z"
                            fill="#1976D2"
                          />
                          <path
                            d="M12.7157 12.375L11.9828 15.2249L10.2044 18.337C9.95328 18.7765 10.1059 19.3366 10.5454 19.5878C10.6884 19.6694 10.8452 19.7083 10.9992 19.7083C11.3173 19.7083 11.6267 19.5429 11.7958 19.2463L13.6291 16.038C13.6658 15.9738 13.6947 15.906 13.7148 15.8354L14.7021 12.375H12.7157Z"
                            fill="url(#paint5_linear_675_361)"
                          />
                          <path
                            d="M19.658 10.638L18.0447 9.83134L16.2443 7.14322C16.0454 6.84026 15.7493 6.59871 15.3758 6.48551C15.2222 6.43921 15.0673 6.41722 14.9147 6.41676C14.2235 6.41447 13.5855 6.86134 13.3747 7.55526L11.9855 12.1386C11.8113 12.7138 11.9832 13.3046 12.3696 13.7111C13.0053 14.3798 15.1709 15.9771 15.1709 15.9771L15.5926 18.9196C15.6567 19.378 16.0509 19.708 16.5001 19.708C16.5413 19.708 16.5872 19.7034 16.6284 19.6988C17.089 19.6319 17.419 19.2395 17.4167 18.7913C17.4167 18.7491 17.414 18.706 17.4076 18.663L16.9492 15.4546C16.9263 15.2805 16.853 15.12 16.7384 14.9871L15.0838 12.9787L15.978 10.028L16.6513 11.0455C16.743 11.183 16.8622 11.2884 17.0088 11.3617L18.8422 12.2784C18.9705 12.343 19.1126 12.3751 19.2501 12.3751C19.5847 12.3751 19.9101 12.1918 20.0705 11.8663C20.2951 11.4172 20.1117 10.8672 19.658 10.638Z"
                            fill="url(#paint6_linear_675_361)"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_675_361"
                              x1="14.6667"
                              y1="2.29175"
                              x2="18.3334"
                              y2="5.95841"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#FD6E6A" />
                              <stop offset="1" stopColor="#FFC600" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_675_361"
                              x1="3.24243"
                              y1="18.3816"
                              x2="4.64854"
                              y2="19.5454"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#F05F57" />
                              <stop offset="1" stopColor="#360940" />
                            </linearGradient>
                            <linearGradient
                              id="paint2_linear_675_361"
                              x1="9.16675"
                              y1="6.70264"
                              x2="15.2971"
                              y2="12.7751"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#3C8CE7" />
                              <stop offset="1" stopColor="#00EAFF" />
                            </linearGradient>
                            <linearGradient
                              id="paint3_linear_675_361"
                              x1="1.83325"
                              y1="12.8333"
                              x2="8.24992"
                              y2="19.2499"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#FFAA85" />
                              <stop offset="1" stopColor="#B3315F" />
                            </linearGradient>
                            <linearGradient
                              id="paint4_linear_675_361"
                              x1="3.20825"
                              y1="17.875"
                              x2="5.04158"
                              y2="19.7083"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#F05F57" />
                              <stop offset="1" stopColor="#360940" />
                            </linearGradient>
                            <linearGradient
                              id="paint5_linear_675_361"
                              x1="10.0835"
                              y1="12.375"
                              x2="16.6973"
                              y2="16.5404"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#3C8CE7" />
                              <stop offset="1" stopColor="#00EAFF" />
                            </linearGradient>
                            <linearGradient
                              id="paint6_linear_675_361"
                              x1="11.9175"
                              y1="6.41675"
                              x2="23.8277"
                              y2="13.8085"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#3C8CE7" />
                              <stop offset="1" stopColor="#00EAFF" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <span>{lang?.Trips}</span>
                      </Tab>
                    )}
                  {(data?.user_data?.role_id === constant.rolesId.restaurant ||
                    data?.user_data?.role_id ===
                    constant.rolesId.voiceOfExpert ||
                    data?.user_data?.role_id === constant.rolesId.importer ||
                    data?.user_data?.role_id === constant.rolesId.distributer ||
                    data?.user_data?.role_id ===
                    constant.rolesId["importer&distributer"]) && (
                      <Tab
                        className="TabInnerList"
                        onClick={() => setContactInfo(false)}
                      >
                        <svg
                          width="21"
                          height="21"
                          viewBox="0 0 21 21"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M13.7812 6.125C12.9369 6.125 12.25 5.43813 12.25 4.59375C12.25 3.74938 12.9369 3.0625 13.7812 3.0625C14.6256 3.0625 15.3125 3.74938 15.3125 4.59375C15.3125 5.43813 14.6256 6.125 13.7812 6.125ZM5.90625 6.5625C6.75062 6.5625 7.4375 5.87563 7.4375 5.03125C7.4375 4.18688 6.75062 3.5 5.90625 3.5C5.06188 3.5 4.375 4.18688 4.375 5.03125C4.375 5.87563 5.06188 6.5625 5.90625 6.5625Z"
                            fill="url(#paint0_linear_294_646)"
                          />
                          <path
                            d="M16.625 8.31248L16.268 11.8816L17.4077 14.9209C17.4497 15.0049 17.4777 15.095 17.4908 15.1882L17.9283 18.2507C17.9966 18.7294 17.6641 19.1721 17.1863 19.2408C16.7086 19.3099 16.2654 18.977 16.1963 18.4988L15.7789 15.5767L14.4375 13.125L12.6223 15.6638L11.7788 18.6156C11.669 18.9997 11.3186 19.2504 10.9379 19.2504C10.8583 19.2504 10.7774 19.2395 10.6969 19.2163C10.2323 19.0833 9.96319 18.5994 10.0962 18.1344L10.9712 15.0719C10.9922 14.9984 11.0228 14.9279 11.0622 14.8623L12.8209 11.4861L13.125 8.74998L11.3313 10.1592L10.9283 12.5768C10.8749 12.8975 10.5967 13.125 10.2821 13.125C10.2463 13.125 10.2099 13.1219 10.1732 13.1158C9.81619 13.0563 9.57425 12.7181 9.63419 12.3602L10.0717 9.73523C10.0944 9.60048 10.1583 9.47579 10.255 9.37954L12.4425 7.19204C12.5453 7.08879 12.6805 7.02273 12.8249 7.00479L15.5706 6.60711L16.7059 4.71492L18.0071 2.11267C18.1694 1.78892 18.5631 1.65767 18.8878 1.81911C19.2119 1.98142 19.3432 2.37517 19.1813 2.69979L17.8688 5.32479C17.8609 5.33967 17.8531 5.35454 17.8443 5.36898L16.625 8.31248ZM9.95225 5.39523C10.0647 5.22679 10.0927 5.01592 10.0288 4.82342L9.15381 2.19842C9.03963 1.85498 8.66819 1.66904 8.32388 1.78367C7.98 1.89829 7.7945 2.26973 7.90913 2.61361L8.68263 4.93411L7.27344 7.04811L4.82606 7.39767L3.10931 5.68092L3.49125 3.38929C3.55075 3.03186 3.30925 2.69323 2.95181 2.63417C2.59175 2.57511 2.25575 2.81617 2.19669 3.17317L1.75919 5.79817C1.72419 6.00773 1.79244 6.22036 1.9425 6.37042L4.11644 9.27936C3.09225 11.3216 2.70594 11.3798 2.63769 12.3283C2.61581 12.4582 2.61013 12.5829 2.625 12.6875C2.625 12.7697 2.63856 12.8397 2.65781 12.9036L3.50875 18.4988C3.577 18.9774 4.0215 19.3099 4.49881 19.2408C4.977 19.1725 5.3095 18.7294 5.24081 18.2507L4.8125 13.125C4.97831 13.0677 5.16863 12.869 5.334 12.8039L6.93613 15.0237L6.15125 18.1628C6.034 18.6318 6.31925 19.1069 6.78781 19.2242C6.85913 19.2421 6.93044 19.2504 7.00088 19.2504C7.39288 19.2504 7.74944 18.9853 7.84875 18.5876L8.72375 15.0876C8.7815 14.857 8.74256 14.6129 8.617 14.4117L7.4375 11.8125L7.875 9.18748L9.95225 5.39523Z"
                            fill="url(#paint1_linear_294_646)"
                          />
                          <path
                            d="M4.84312 13.0856L4.8125 13.125L4.86719 13.3989L4.84312 13.0856Z"
                            fill="#1976D2"
                          />
                          <defs>
                            <linearGradient
                              id="paint0_linear_294_646"
                              x1="4.375"
                              y1="3.0625"
                              x2="6.40693"
                              y2="9.41228"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#FCCF31" />
                              <stop offset="1" stopColor="#F55555" />
                            </linearGradient>
                            <linearGradient
                              id="paint1_linear_294_646"
                              x1="1.75018"
                              y1="1.74982"
                              x2="19.2508"
                              y2="19.2503"
                              gradientUnits="userSpaceOnUse"
                            >
                              <stop stopColor="#79F1A4" />
                              <stop offset="1" stopColor="#0E5CAD" />
                            </linearGradient>
                          </defs>
                        </svg>
                        <span>{lang?.Events}</span>
                      </Tab>
                    )}
                </TabList>
                <TabPanel>
                  <div className="tab-content-section">
                    {/* <UserSocialPost /> */}
                    <VisitorPost />
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="card card--block">
                    {data?.posts?.data?.length === 0 && (
                      <div className="post--form emptyData">
                        <div className="empty_notification">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="84.206"
                            height="67.365"
                            viewBox="0 0 84.206 67.365"
                          >
                            <path
                              id="icons8_image"
                              d="M0,5V72.364H84.206V5ZM3.368,8.368H80.837V52.155H62.852L51.063,43.735H41.116l-6.881-6.881-8.2,1.645L18.788,27.617,3.368,43.037Zm59.786,10.1a7.579,7.579,0,1,0,7.578,7.579A7.606,7.606,0,0,0,63.154,18.473Zm0,3.368a4.21,4.21,0,1,1-4.21,4.21A4.189,4.189,0,0,1,63.154,21.841ZM18.262,32.906l6.223,9.328,8.644-1.724L39.721,47.1H49.984l11.789,8.421H80.837V69H3.368V47.8Z"
                              transform="translate(0 -5)"
                            />
                          </svg>
                          <h3 className="font-20 font-bold mt-5 mb-3">
                            {lang?.Photos}
                          </h3>
                          <h4 className="font-18 text-normal text-black">
                            {lang?.there_is_no_photo_at_this_moment}
                          </h4>
                        </div>
                      </div>
                    )}
                    <div className="user_all_detail">
                      <div className="postGallery">
                        <ul className="flex flex-wrap">
                          {data?.posts?.data?.map((items, index) => {
                            return items.attachments.map((item, indx) => {
                              return (
                                <li className="w-1/3" key={indx}>
                                  <img
                                    src={`${item?.attachment_link?.base_url}${item &&
                                      item?.attachment_link?.attachment_url
                                      }`}
                                    alt="Post Image"
                                    onClick={() => {
                                      handlePhotos(
                                        `${item?.attachment_link?.base_url}${item &&
                                        item?.attachment_link?.attachment_url
                                        }`
                                      );
                                    }}
                                  // onClick={() => history.push(`${"/home/post/activity/"}${item?.action_id}`)}
                                  />
                                  {/* <img src={`${item && item.attachment_link && item.attachment_link.base_url}${item && item.attachment_link && item.attachment_link.attachment_url}`} alt="Post Image" /> */}
                                </li>
                              );
                            });
                          })}
                        </ul>
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="card card--block">
                    <div className="profile-options-lists">
                      <div className="user_all_detail">
                        {data?.about_tab?.map((item, index) => {
                          if (item.type === "checkbox") {
                            const val = item && item.value.split(",");
                            return (
                              <Fragment key={index}>
                                <div className="blockRow">
                                  <h4 className="font-size-18 pb-2">
                                    {item.title}
                                  </h4>
                                  <div className="selectedProduct">
                                    <ul>
                                      {val &&
                                        val.map((v, i) => (
                                          <li>
                                            <Link to="#" key={i}>
                                              {v}
                                            </Link>
                                          </li>
                                        ))}
                                    </ul>
                                  </div>
                                </div>
                              </Fragment>
                            );
                          }
                          if (item.type === "multiselect") {
                            return (
                              <Fragment key={index}>
                                <div className="blockRow">
                                  <h4 className="font-size-18 pb-2">
                                    {item.title}
                                  </h4>
                                  <p className="mb-6">{item.value}</p>
                                </div>
                              </Fragment>
                            );
                          } else {
                            if (item.value != "0%") {
                              return (
                                <Fragment key={index}>
                                  <div className="blockRow">
                                    <h4 className="font-size-18 pb-2">
                                      {item.title}
                                    </h4>
                                    {item.type === "text" ? (
                                      <Fragment>
                                        {/* <SeeMore item={item} /> */}
                                        <ReactReadMoreReadLess
                                          charLimit={150}
                                          readMoreText={"See more"}
                                          readLessText={"See less"}
                                          readMoreClassName="read-more-less--more"
                                          readLessClassName="read-more-less--less"
                                        >
                                          {item?.value}
                                        </ReactReadMoreReadLess>
                                      </Fragment>
                                    ) : (
                                      <p className="">{item.value}</p>
                                    )}
                                  </div>
                                </Fragment>
                              );
                            }
                          }
                        })}
                      </div>
                    </div>
                  </div>
                </TabPanel>
                <TabPanel>
                  <div className="card card--block">
                    <VisitorContact />
                  </div>
                </TabPanel>

                {data?.user_data?.role_id !== constant.rolesId.voyagers && (
                  <TabPanel>
                    <div className="card card--block">
                      <div className="flex flex-wrap justify-between mb-6">
                        <h4 className="font-size-18 mb-4">{lang?.Awards} </h4>
                      </div>
                      <AwardView visitorId={data?.user_data?.user_id} />
                    </div>
                  </TabPanel>
                )}

                {data?.user_data?.role_id ===
                  constant.rolesId.voiceOfExpert && (
                    <TabPanel>
                      <div className="card card--block">
                        <div className="flex flex-wrap justify-between mb-6">
                          <h4 className="font-size-18 mb-4">{lang?.Blogs}</h4>
                        </div>
                        <BlogView visitorId={data?.user_data?.user_id} />
                      </div>
                    </TabPanel>
                  )}
                {data?.user_data?.role_id ===
                  constant.rolesId.travelAgencies && (
                    <TabPanel>
                      <div className="card card--block">
                        <div className="flex flex-wrap justify-between mb-6">
                          <h4 className="font-size-18 mb-4">{lang?.Trips}</h4>
                        </div>
                        <TripView visitorId={data?.user_data?.user_id} />
                      </div>
                    </TabPanel>
                  )}
                {(data?.user_data?.role_id === constant.rolesId.restaurant ||
                  data?.user_data?.role_id === constant.rolesId.voiceOfExpert ||
                  data?.user_data?.role_id === constant.rolesId.importer ||
                  data?.user_data?.role_id === constant.rolesId.distributer ||
                  data?.user_data?.role_id ===
                  constant.rolesId["importer&distributer"]) && (
                    <TabPanel>
                      <div className="card card--block">
                        <div className="flex flex-wrap justify-between mb-6">
                          <h4 className="font-size-18 mb-4">{lang?.Events}</h4>
                        </div>
                        <EventView visitorId={data?.user_data?.user_id} />
                      </div>
                    </TabPanel>
                  )}
              </Tabs>
            </div>
          </div>

          {/* Tab Content Right Section */}
          {rightSection()}
        </div>
      </div>
      {/* } */}

      {/* connet modal */}
      {connectPopup && (
        <Modal
          isOpen={connectPopup}
          ariaHideApp={false}
          style={{
            overlay: {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.75)",
            },
            content: {
              position: "absolute",
              top: "0",
              left: "0%",
              right: "0%",
              bottom: "200px",
              border: "1px solid #ccc",
              background: "#fff",
              overflow: "auto",
              WebkitOverflowScrolling: "touch",
              borderRadius: "4px",
              padding: "0",
              // outline: 'none',
            },
          }}
        >
          <div className="popup_header flex justify-between items-center">
            <h4 className="page__title">{lang?.Connections}</h4>
            <button
              className="close_btn--modal"
              onClick={() => setConnectPopup(!connectPopup)}
            >
              {lang?.close}
            </button>
          </div>
          <div className="card card--block modal_box modalLessGap">
            <h4 style={{ color: "red" }}>{responseErrors}</h4>
            {/* <h4 className='font-16 mb-2'>
            {lang?.sending_request_with} <strong>@
              {
                data && data.user_data && data.user_data.first_name !== null && data.user_data.last_name !== null &&
                `${data.user_data && data.user_data.first_name}${data.user_data && data.user_data.last_name}`
                || data && data.user_data && data.user_data.company_name || data && data.user_data && data.user_data.restaurant_name
              }
            </strong></h4> */}
            <p className="font-16 mb-2">{lang?.Reason_to_connect}</p>
            <form>
              <textarea
                className="write_post-area w-full"
                placeholder={lang?.Enter_your_text}
                rows="2"
                value={connectText}
                onChange={(e) => setConnectText(e.target.value)}
              />
            </form>
            <div className="view__hub__btn">
              {/* <Link to={"#"}
              className="btn BgTeal"
              onClick={() => sendRequest()}
            >
              {!sendRequestSpinner ? <FormSpinner /> : "Send Request"}
            </Link> */}
              <button
                type="button"
                className="btn btnTeal"
                onClick={() => sendRequest()}
              >
                {sendRequestSpinner ? <FormSpinner /> : `${lang?.Send_Request}`}
              </button>
            </div>
          </div>
          <div></div>
        </Modal>
      )}
      {/* connect importer modal */}

      {connectToImporter && (
        <ImporterModel
          data={{
            openModel: connectToImporter,
            data: data,
            handleModel: handleModal,
            userId: params.id,
          }}
        />
      )}

      {/* feature product view */}
      {featureProductViewModal && (
        <Modal
          isOpen={featureProductViewModal}
          ariaHideApp={false}
          style={{
            overlay: {
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.75)",
            },
            content: {
              position: "absolute",
              top: "140px",
              left: "30%",
              right: "30%",
              bottom: "200px",
              border: "1px solid #ccc",
              background: "#fff",
              overflow: "auto",
              WebkitOverflowScrolling: "touch",
              borderRadius: "4px",
              // outline: 'none',
              padding: "20px",
            },
          }}
        >
          <button
            className="close_btn--modal"
            onClick={() => setFeatureProductViewModal(false)}
          >
            {lang?.close}
          </button>

          <form>
            <div className="form__item">
              <label style={{display:hide==true?"none":""}} htmlFor="email">{lang?.IMAGE}</label>
              <img src={featureProductPhoto} />
            </div>
            <div  className={`form__item ${hide==true?"d-none":""}`}>
              <label  htmlFor="email">{lang?.TITLE}</label>
              <input
                name="text"
                type="text"
                defaultValue={featureProductTitle}
                readOnly
              />
            </div>
            {featureProductUrl != null && featureProductUrl != "null" && (
              <div className={`form__item ${hide==true?"d-none":""}`}>
                <label htmlFor="email">{lang?.URL}</label>
                {featureProductUrl.includes("https://") ? (
                  <a href={featureProductUrl} target="_blank">
                    {featureProductUrl}
                  </a>
                ) : (
                  <a href={`https://${featureProductUrl}`} target="_blank">
                    {featureProductUrl}
                  </a>
                )}
              </div>
            )}
            {description !== null && (
              <div   className={`form__item ${hide==true?"d-none":""}`}>
                <label htmlFor="email">{lang?.Description}</label>
                <textarea
                  name="text"
                  type="text"
                  defaultValue={description}
                  readOnly
                />
              </div>
            )}
            {/*<div className="form__action form__item">
           <button type="button" >Save</button>
      </div>*/}
          </form>
        </Modal>
      )}

      {/* user photos view */}

      {isOpenImage && (
        <div className="image--light--pop">
          <ReactImageVideoLightbox
            data={userPhotosData}
            startIndex={imageIndex}
            showResourceCount={true}
            onCloseCallback={() => {
              setIsOpenImage(false);
              setUserPhotosData([]);
              setImageIndex(0);
            }}
          // onNavigationCallback={(currentIndex) =>
          //     console.log(`Current index: ${currentIndex}`)
          // }
          />
        </div>
      )}

      {/* Report Post Popup Start */}

      {isReportModal && (
        <Modal
          className="reportModal"
          isOpen={isReportModal}
          ariaHideApp={false}
          contentLabel=""
          style={{
            overlay: {
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: "rgba(255, 255, 255, 0.75)",
            },
            content: {
              position: "absolute",
              top: "0",
              left: "0%",
              right: "0%",
              bottom: "200px",
              border: "1px solid #ccc",
              background: "#fff",
              overflow: "auto",
              WebkitOverflowScrolling: "touch",
              borderRadius: "4px",
              padding: "0",
            },
          }}
        >
          <div className="modalHeader flex items-center">
            <div
              className="headerTitle w-full text-center font-28"
              style={{ color: "#3296ff" }}
            >
              Report
            </div>
            <button
              className="close"
              onClick={() => {
                setIsReportModal(false);
              }}
            >
              <svg
                id="Icons_Alerts_alarm"
                data-name="Icons/Alerts/alarm"
                xmlns="http://www.w3.org/2000/svg"
                width="21.037"
                height="21.04"
                viewBox="0 0 21.037 21.04"
              >
                <path
                  id="close"
                  d="M2.4.412A1.405,1.405,0,1,0,.412,2.4l8.117,8.117L.412,18.634A1.405,1.405,0,1,0,2.4,20.622l8.117-8.112,8.117,8.117a1.405,1.405,0,1,0,1.988-1.988L12.51,10.517,20.627,2.4A1.407,1.407,0,1,0,18.634.412L10.516,8.529Z"
                  transform="translate(0 0.001)"
                  fill="#171717"
                />
              </svg>
            </button>
          </div>
          <div className="modalBody">
            <h4 className="problem-post font-18 font-bold">
              {lang?.Report_Problem}
            </h4>
            <div className="report-post">
              {reasonError && (
                <div className="errorMsg">
                  {"Please select a problem with the User."}
                </div>
                // <div className="errorMsg">{lang?.One_Reason_Choose}</div>
              )}
              <form onSubmit={reportUsers}>
                <ul className="problems">
                  <li>{lang?.Nudity}</li>
                  <li>
                    <input
                      type="radio"
                      name="problem_with_post"
                      className="select-checkbox"
                      onClick={() => addPostReason("Nudity")}
                    />
                  </li>
                </ul>
                <ul className="problems">
                  <li>{lang?.Violence}</li>
                  <li>
                    <input
                      type="radio"
                      name="problem_with_post"
                      className="select-checkbox"
                      onClick={() => addPostReason("Violence")}
                    />
                  </li>
                </ul>
                <ul className="problems">
                  <li>{lang?.Harassment}</li>
                  <li>
                    <input
                      type="radio"
                      name="problem_with_post"
                      className="select-checkbox"
                      onClick={() => addPostReason("Harassment")}
                    />
                  </li>
                </ul>
                <ul className="problems">
                  <li>{lang?.Suicide}</li>
                  <li>
                    <input
                      type="radio"
                      name="problem_with_post"
                      className="select-checkbox"
                      onClick={() => addPostReason("Suicide")}
                    />
                  </li>
                </ul>
                <ul className="problems">
                  <li>{lang?.False_Info}</li>
                  <li>
                    <input
                      type="radio"
                      name="problem_with_post"
                      className="select-checkbox"
                      onClick={() => addPostReason("False Information")}
                    />
                  </li>
                </ul>
                <ul className="problems">
                  <li>{lang?.Others}</li>
                  <li>
                    <input
                      type="radio"
                      name="problem_with_post"
                      className="select-checkbox"
                      onClick={() => addPostReason("Other")}
                    />
                  </li>
                </ul>
                {allowOtherReason ? (
                  <div className="other_reason">
                    <textarea
                      className="my_reason"
                      placeholder={lang?.Write_Reason}
                      onChange={(e) => {
                        setOtherReason(e.target.value);
                        setOtherReasonError(false);
                      }}
                    ></textarea>
                    {otherReasonError ? (
                      <div className="errorMsg field-required">
                        {lang?.Write_Reason} {lang?.is_required}.
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}

                <div className="submitReport">
                  <button className="savedReport" type="submit">
                    {isSubmitReport ? <FormSpinner /> : lang?.only_Submit}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>
      )}

      {/* Block Popup start */}
      {blockPopup && (
        <div>
          <Modal
            ariaHideApp={false}
            isOpen={blockPopup}
            style={{
              overlay: {
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: "rgba(255, 255, 255, 0.75)",
              },
              content: {
                position: "absolute",
                top: "0",
                left: "0%",
                right: "0%",
                bottom: "200px",
                border: "1px solid #ccc",
                background: "#fff",
                overflow: "auto",
                WebkitOverflowScrolling: "touch",
                borderRadius: "10px",
                padding: "0",
              },
            }}
          >
            <div className="popup_header flex justify-between items-center popupheaderBg">
              <h4 className="page__title">{(!data?.user_data?.block_flag) ? lang?.Block : lang?.UnBlock}</h4>
              <button
                className="close_btn--modal"
                onClick={() => setBlockPopup(!blockPopup)}
              >
                {lang?.close}
              </button>
            </div>
            <div className="card card--block modal_box">
              {(!data?.user_data?.block_flag) ? (
                <>
                  <h3 className="text-20 mb-8">
                    {lang?.BLOCK_USERS_HINT_AND_MESSAGES}
                  </h3>
                  <p className="">{lang?.YOU_WANT_TO_BLOCK_USERS}</p>
                </>
              ) : (
                <>
                  <h3 className="text-20 mb-8">
                    {lang?.REALY_WANT_TO_UNBLOCK_USER}.
                  </h3>
                </>
              )}
              <div className="right__btn text-right">
                <Link
                  className="btn btn1"
                  to="#"
                  onClick={() => setBlockPopup(false)}
                >
                  {" "}
                  {lang?.Cancel}{" "}
                </Link>
                <Link
                  className="btn btn2 ml-3"
                  to="#"
                  onClick={() =>
                    (!data?.user_data?.block_flag)
                      ? blockUsers()
                      : handleUnblockReq(true)
                  }
                >
                  {lang?.ok}
                </Link>
              </div>
            </div>
          </Modal>
        </div>
      )}
    </Fragment>
  );
}
